import React, { useState, useEffect } from 'react';
import { getEmployees } from '../../api/axios';
import DataTable from '../Table/DataTable';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';

const Employees = () => {
  const { t } = useTranslation('global');

  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  

  const fetchEmployees = async() =>{
    const response = await getEmployees();
    console.log(response);
    setEmployees(response);
    
    setLoading(false);
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const columns = [
    { Header: t("list.id"), accessor: 'id' },
    { Header: t("list.cardNo"), accessor: 'serial_num' },
    { Header: t("list.firstName"), accessor: 'name' },
    { Header: t("list.lastName"), accessor: 'last_name' },
    { Header: t("list.active"), accessor: 'active' },
    { Header: t("list.sector"), accessor: 'sector' },
    { Header: t("list.organizationUnit"), accessor: 'organization_unit_id' },
    { Header: t("list.workplace"), accessor:'workplace'},
    { Header: t("list.section"), accessor:'section'},
    { Header: t("list.limitType"), accessor: 'limit_type' },
    { Header: t("list.monthlyLimit"), accessor: 'monthly_limit_id' },
    { Header: t("list.dailyLimit"), accessor: 'daily_limit' },
    { Header: t("list.credit"), accessor: 'credit' },
    { Header: t("list.holiday"), accessor: 'holiday_name'},
    { Header: t("list.holidayDate"), accessor: 'holiday_date'},
    { Header: t("list.note"), accessor: 'note'},

  ];

  if (loading) {
    return <p>{t("list.loading")}</p>;
  }

  return (
    <Container sx={{ mt: 5 }} fullWidth maxWidth="xl">
      <DataTable initialData={employees} columns={columns} entityName="employees" h2={t("list.employees")} />
    </Container>
  );
};

export default Employees;
